// Mirror of backend/src/errors/codes.ts (OME-180).
// Kept in sync manually for now; follow-up ticket promotes to shared package.

export const ERROR_CODES = [
  'OTP_INVALID',
  'OTP_EXPIRED',
  'OTP_MAX_ATTEMPTS',
  'SHORT_LINK_GONE',
  'BOOKING_CONFLICT',
  'UNKNOWN_ERROR',
] as const;
export type ErrorCode = typeof ERROR_CODES[number];

export const ACTION_TYPES = [
  'retry',
  'resend_otp',
  'call_business',
  'pick_other_slot',
  'refresh',
  'none',
] as const;
export type ActionType = typeof ACTION_TYPES[number];

export const INLINE_ERROR_CODES: ErrorCode[] = ['OTP_INVALID', 'OTP_EXPIRED'];

export type NormalizedError = {
  code: ErrorCode;
  message: string;
  action: {
    type: ActionType;
    label: string;
    payload?: Record<string, unknown>;
  };
};
